/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AppRouteImport } from './routes/_app';
import { Route as IngresarRouteImport } from './routes/ingresar';
import { Route as OlvideContrasenaRouteImport } from './routes/olvide-contrasena';
import { Route as AppIndexRouteImport } from './routes/_app/index';
import { Route as AppAdministradoresRouteImport } from './routes/_app/administradores';
import { Route as AppAuditoriaRouteImport } from './routes/_app/auditoria';
import { Route as AppConfiguracionRouteImport } from './routes/_app/configuracion';
import { Route as AppEmpresasRouteImport } from './routes/_app/empresas';
import { Route as AppHorariosRouteImport } from './routes/_app/horarios';
import { Route as AppIntegracionRouteImport } from './routes/_app/integracion';
import { Route as AppMarcacionesRouteImport } from './routes/_app/marcaciones';
import { Route as AppMarcadoresRouteImport } from './routes/_app/marcadores';
import { Route as AppPerfilRouteImport } from './routes/_app/perfil';
import { Route as AppSedesRouteImport } from './routes/_app/sedes';
import { Route as AppSolicitudesRouteImport } from './routes/_app/solicitudes';
import { Route as AppTareoRouteImport } from './routes/_app/tareo';
import { Route as AppTrabajadoresRouteImport } from './routes/_app/trabajadores';
import { Route as ContrasenaTokenRouteImport } from './routes/contrasena.$token';
import { Route as AppEmpresasCompanyIdRouteImport } from './routes/_app/empresas_.$companyId';
import { Route as AppMarcadoresTerminalIdRouteImport } from './routes/_app/marcadores_.$terminalId';
import { Route as AppSedesSiteIdRouteImport } from './routes/_app/sedes_.$siteId';
import { Route as AppTrabajadoresWorkerIdRouteImport } from './routes/_app/trabajadores_.$workerId';
import { Route as AppIntegracionEjecucionesRunIdRouteImport } from './routes/_app/integracion_.ejecuciones.$runId';

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any);
const IngresarRoute = IngresarRouteImport.update({
  id: '/ingresar',
  path: '/ingresar',
  getParentRoute: () => rootRouteImport,
} as any);
const OlvideContrasenaRoute = OlvideContrasenaRouteImport.update({
  id: '/olvide-contrasena',
  path: '/olvide-contrasena',
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any);
const AppAdministradoresRoute = AppAdministradoresRouteImport.update({
  id: '/administradores',
  path: '/administradores',
  getParentRoute: () => AppRoute,
} as any);
const AppAuditoriaRoute = AppAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AppRoute,
} as any);
const AppConfiguracionRoute = AppConfiguracionRouteImport.update({
  id: '/configuracion',
  path: '/configuracion',
  getParentRoute: () => AppRoute,
} as any);
const AppEmpresasRoute = AppEmpresasRouteImport.update({
  id: '/empresas',
  path: '/empresas',
  getParentRoute: () => AppRoute,
} as any);
const AppHorariosRoute = AppHorariosRouteImport.update({
  id: '/horarios',
  path: '/horarios',
  getParentRoute: () => AppRoute,
} as any);
const AppIntegracionRoute = AppIntegracionRouteImport.update({
  id: '/integracion',
  path: '/integracion',
  getParentRoute: () => AppRoute,
} as any);
const AppMarcacionesRoute = AppMarcacionesRouteImport.update({
  id: '/marcaciones',
  path: '/marcaciones',
  getParentRoute: () => AppRoute,
} as any);
const AppMarcadoresRoute = AppMarcadoresRouteImport.update({
  id: '/marcadores',
  path: '/marcadores',
  getParentRoute: () => AppRoute,
} as any);
const AppPerfilRoute = AppPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AppRoute,
} as any);
const AppSedesRoute = AppSedesRouteImport.update({
  id: '/sedes',
  path: '/sedes',
  getParentRoute: () => AppRoute,
} as any);
const AppSolicitudesRoute = AppSolicitudesRouteImport.update({
  id: '/solicitudes',
  path: '/solicitudes',
  getParentRoute: () => AppRoute,
} as any);
const AppTareoRoute = AppTareoRouteImport.update({
  id: '/tareo',
  path: '/tareo',
  getParentRoute: () => AppRoute,
} as any);
const AppTrabajadoresRoute = AppTrabajadoresRouteImport.update({
  id: '/trabajadores',
  path: '/trabajadores',
  getParentRoute: () => AppRoute,
} as any);
const ContrasenaTokenRoute = ContrasenaTokenRouteImport.update({
  id: '/contrasena/$token',
  path: '/contrasena/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const AppEmpresasCompanyIdRoute = AppEmpresasCompanyIdRouteImport.update({
  id: '/empresas_/$companyId',
  path: '/empresas/$companyId',
  getParentRoute: () => AppRoute,
} as any);
const AppMarcadoresTerminalIdRoute = AppMarcadoresTerminalIdRouteImport.update({
  id: '/marcadores_/$terminalId',
  path: '/marcadores/$terminalId',
  getParentRoute: () => AppRoute,
} as any);
const AppSedesSiteIdRoute = AppSedesSiteIdRouteImport.update({
  id: '/sedes_/$siteId',
  path: '/sedes/$siteId',
  getParentRoute: () => AppRoute,
} as any);
const AppTrabajadoresWorkerIdRoute = AppTrabajadoresWorkerIdRouteImport.update({
  id: '/trabajadores_/$workerId',
  path: '/trabajadores/$workerId',
  getParentRoute: () => AppRoute,
} as any);
const AppIntegracionEjecucionesRunIdRoute =
  AppIntegracionEjecucionesRunIdRouteImport.update({
    id: '/integracion_/ejecuciones/$runId',
    path: '/integracion/ejecuciones/$runId',
    getParentRoute: () => AppRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute;
  '/ingresar': typeof IngresarRoute;
  '/olvide-contrasena': typeof OlvideContrasenaRoute;
  '/administradores': typeof AppAdministradoresRoute;
  '/auditoria': typeof AppAuditoriaRoute;
  '/configuracion': typeof AppConfiguracionRoute;
  '/empresas': typeof AppEmpresasRoute;
  '/horarios': typeof AppHorariosRoute;
  '/integracion': typeof AppIntegracionRoute;
  '/marcaciones': typeof AppMarcacionesRoute;
  '/marcadores': typeof AppMarcadoresRoute;
  '/perfil': typeof AppPerfilRoute;
  '/sedes': typeof AppSedesRoute;
  '/solicitudes': typeof AppSolicitudesRoute;
  '/tareo': typeof AppTareoRoute;
  '/trabajadores': typeof AppTrabajadoresRoute;
  '/contrasena/$token': typeof ContrasenaTokenRoute;
  '/empresas/$companyId': typeof AppEmpresasCompanyIdRoute;
  '/marcadores/$terminalId': typeof AppMarcadoresTerminalIdRoute;
  '/sedes/$siteId': typeof AppSedesSiteIdRoute;
  '/trabajadores/$workerId': typeof AppTrabajadoresWorkerIdRoute;
  '/integracion/ejecuciones/$runId': typeof AppIntegracionEjecucionesRunIdRoute;
}
export interface FileRoutesByTo {
  '/ingresar': typeof IngresarRoute;
  '/olvide-contrasena': typeof OlvideContrasenaRoute;
  '/administradores': typeof AppAdministradoresRoute;
  '/auditoria': typeof AppAuditoriaRoute;
  '/configuracion': typeof AppConfiguracionRoute;
  '/empresas': typeof AppEmpresasRoute;
  '/horarios': typeof AppHorariosRoute;
  '/integracion': typeof AppIntegracionRoute;
  '/marcaciones': typeof AppMarcacionesRoute;
  '/marcadores': typeof AppMarcadoresRoute;
  '/perfil': typeof AppPerfilRoute;
  '/sedes': typeof AppSedesRoute;
  '/solicitudes': typeof AppSolicitudesRoute;
  '/tareo': typeof AppTareoRoute;
  '/trabajadores': typeof AppTrabajadoresRoute;
  '/contrasena/$token': typeof ContrasenaTokenRoute;
  '/': typeof AppIndexRoute;
  '/empresas/$companyId': typeof AppEmpresasCompanyIdRoute;
  '/marcadores/$terminalId': typeof AppMarcadoresTerminalIdRoute;
  '/sedes/$siteId': typeof AppSedesSiteIdRoute;
  '/trabajadores/$workerId': typeof AppTrabajadoresWorkerIdRoute;
  '/integracion/ejecuciones/$runId': typeof AppIntegracionEjecucionesRunIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_app': typeof AppRouteWithChildren;
  '/ingresar': typeof IngresarRoute;
  '/olvide-contrasena': typeof OlvideContrasenaRoute;
  '/_app/administradores': typeof AppAdministradoresRoute;
  '/_app/auditoria': typeof AppAuditoriaRoute;
  '/_app/configuracion': typeof AppConfiguracionRoute;
  '/_app/empresas': typeof AppEmpresasRoute;
  '/_app/horarios': typeof AppHorariosRoute;
  '/_app/integracion': typeof AppIntegracionRoute;
  '/_app/marcaciones': typeof AppMarcacionesRoute;
  '/_app/marcadores': typeof AppMarcadoresRoute;
  '/_app/perfil': typeof AppPerfilRoute;
  '/_app/sedes': typeof AppSedesRoute;
  '/_app/solicitudes': typeof AppSolicitudesRoute;
  '/_app/tareo': typeof AppTareoRoute;
  '/_app/trabajadores': typeof AppTrabajadoresRoute;
  '/contrasena/$token': typeof ContrasenaTokenRoute;
  '/_app/': typeof AppIndexRoute;
  '/_app/empresas_/$companyId': typeof AppEmpresasCompanyIdRoute;
  '/_app/marcadores_/$terminalId': typeof AppMarcadoresTerminalIdRoute;
  '/_app/sedes_/$siteId': typeof AppSedesSiteIdRoute;
  '/_app/trabajadores_/$workerId': typeof AppTrabajadoresWorkerIdRoute;
  '/_app/integracion_/ejecuciones/$runId': typeof AppIntegracionEjecucionesRunIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/ingresar'
    | '/olvide-contrasena'
    | '/administradores'
    | '/auditoria'
    | '/configuracion'
    | '/empresas'
    | '/horarios'
    | '/integracion'
    | '/marcaciones'
    | '/marcadores'
    | '/perfil'
    | '/sedes'
    | '/solicitudes'
    | '/tareo'
    | '/trabajadores'
    | '/contrasena/$token'
    | '/empresas/$companyId'
    | '/marcadores/$terminalId'
    | '/sedes/$siteId'
    | '/trabajadores/$workerId'
    | '/integracion/ejecuciones/$runId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/ingresar'
    | '/olvide-contrasena'
    | '/administradores'
    | '/auditoria'
    | '/configuracion'
    | '/empresas'
    | '/horarios'
    | '/integracion'
    | '/marcaciones'
    | '/marcadores'
    | '/perfil'
    | '/sedes'
    | '/solicitudes'
    | '/tareo'
    | '/trabajadores'
    | '/contrasena/$token'
    | '/'
    | '/empresas/$companyId'
    | '/marcadores/$terminalId'
    | '/sedes/$siteId'
    | '/trabajadores/$workerId'
    | '/integracion/ejecuciones/$runId';
  id:
    | '__root__'
    | '/_app'
    | '/ingresar'
    | '/olvide-contrasena'
    | '/_app/administradores'
    | '/_app/auditoria'
    | '/_app/configuracion'
    | '/_app/empresas'
    | '/_app/horarios'
    | '/_app/integracion'
    | '/_app/marcaciones'
    | '/_app/marcadores'
    | '/_app/perfil'
    | '/_app/sedes'
    | '/_app/solicitudes'
    | '/_app/tareo'
    | '/_app/trabajadores'
    | '/contrasena/$token'
    | '/_app/'
    | '/_app/empresas_/$companyId'
    | '/_app/marcadores_/$terminalId'
    | '/_app/sedes_/$siteId'
    | '/_app/trabajadores_/$workerId'
    | '/_app/integracion_/ejecuciones/$runId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
  IngresarRoute: typeof IngresarRoute;
  OlvideContrasenaRoute: typeof OlvideContrasenaRoute;
  ContrasenaTokenRoute: typeof ContrasenaTokenRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ingresar': {
      id: '/ingresar';
      path: '/ingresar';
      fullPath: '/ingresar';
      preLoaderRoute: typeof IngresarRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/olvide-contrasena': {
      id: '/olvide-contrasena';
      path: '/olvide-contrasena';
      fullPath: '/olvide-contrasena';
      preLoaderRoute: typeof OlvideContrasenaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/': {
      id: '/_app/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/administradores': {
      id: '/_app/administradores';
      path: '/administradores';
      fullPath: '/administradores';
      preLoaderRoute: typeof AppAdministradoresRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/auditoria': {
      id: '/_app/auditoria';
      path: '/auditoria';
      fullPath: '/auditoria';
      preLoaderRoute: typeof AppAuditoriaRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/configuracion': {
      id: '/_app/configuracion';
      path: '/configuracion';
      fullPath: '/configuracion';
      preLoaderRoute: typeof AppConfiguracionRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/empresas': {
      id: '/_app/empresas';
      path: '/empresas';
      fullPath: '/empresas';
      preLoaderRoute: typeof AppEmpresasRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/horarios': {
      id: '/_app/horarios';
      path: '/horarios';
      fullPath: '/horarios';
      preLoaderRoute: typeof AppHorariosRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/integracion': {
      id: '/_app/integracion';
      path: '/integracion';
      fullPath: '/integracion';
      preLoaderRoute: typeof AppIntegracionRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/marcaciones': {
      id: '/_app/marcaciones';
      path: '/marcaciones';
      fullPath: '/marcaciones';
      preLoaderRoute: typeof AppMarcacionesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/marcadores': {
      id: '/_app/marcadores';
      path: '/marcadores';
      fullPath: '/marcadores';
      preLoaderRoute: typeof AppMarcadoresRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/perfil': {
      id: '/_app/perfil';
      path: '/perfil';
      fullPath: '/perfil';
      preLoaderRoute: typeof AppPerfilRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/sedes': {
      id: '/_app/sedes';
      path: '/sedes';
      fullPath: '/sedes';
      preLoaderRoute: typeof AppSedesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/solicitudes': {
      id: '/_app/solicitudes';
      path: '/solicitudes';
      fullPath: '/solicitudes';
      preLoaderRoute: typeof AppSolicitudesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/tareo': {
      id: '/_app/tareo';
      path: '/tareo';
      fullPath: '/tareo';
      preLoaderRoute: typeof AppTareoRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/trabajadores': {
      id: '/_app/trabajadores';
      path: '/trabajadores';
      fullPath: '/trabajadores';
      preLoaderRoute: typeof AppTrabajadoresRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/contrasena/$token': {
      id: '/contrasena/$token';
      path: '/contrasena/$token';
      fullPath: '/contrasena/$token';
      preLoaderRoute: typeof ContrasenaTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/empresas_/$companyId': {
      id: '/_app/empresas_/$companyId';
      path: '/empresas/$companyId';
      fullPath: '/empresas/$companyId';
      preLoaderRoute: typeof AppEmpresasCompanyIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/marcadores_/$terminalId': {
      id: '/_app/marcadores_/$terminalId';
      path: '/marcadores/$terminalId';
      fullPath: '/marcadores/$terminalId';
      preLoaderRoute: typeof AppMarcadoresTerminalIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/sedes_/$siteId': {
      id: '/_app/sedes_/$siteId';
      path: '/sedes/$siteId';
      fullPath: '/sedes/$siteId';
      preLoaderRoute: typeof AppSedesSiteIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/trabajadores_/$workerId': {
      id: '/_app/trabajadores_/$workerId';
      path: '/trabajadores/$workerId';
      fullPath: '/trabajadores/$workerId';
      preLoaderRoute: typeof AppTrabajadoresWorkerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/integracion_/ejecuciones/$runId': {
      id: '/_app/integracion_/ejecuciones/$runId';
      path: '/integracion/ejecuciones/$runId';
      fullPath: '/integracion/ejecuciones/$runId';
      preLoaderRoute: typeof AppIntegracionEjecucionesRunIdRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AppRouteChildren {
  AppAdministradoresRoute: typeof AppAdministradoresRoute;
  AppAuditoriaRoute: typeof AppAuditoriaRoute;
  AppConfiguracionRoute: typeof AppConfiguracionRoute;
  AppEmpresasRoute: typeof AppEmpresasRoute;
  AppHorariosRoute: typeof AppHorariosRoute;
  AppIntegracionRoute: typeof AppIntegracionRoute;
  AppMarcacionesRoute: typeof AppMarcacionesRoute;
  AppMarcadoresRoute: typeof AppMarcadoresRoute;
  AppPerfilRoute: typeof AppPerfilRoute;
  AppSedesRoute: typeof AppSedesRoute;
  AppSolicitudesRoute: typeof AppSolicitudesRoute;
  AppTareoRoute: typeof AppTareoRoute;
  AppTrabajadoresRoute: typeof AppTrabajadoresRoute;
  AppIndexRoute: typeof AppIndexRoute;
  AppEmpresasCompanyIdRoute: typeof AppEmpresasCompanyIdRoute;
  AppMarcadoresTerminalIdRoute: typeof AppMarcadoresTerminalIdRoute;
  AppSedesSiteIdRoute: typeof AppSedesSiteIdRoute;
  AppTrabajadoresWorkerIdRoute: typeof AppTrabajadoresWorkerIdRoute;
  AppIntegracionEjecucionesRunIdRoute: typeof AppIntegracionEjecucionesRunIdRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppAdministradoresRoute: AppAdministradoresRoute,
  AppAuditoriaRoute: AppAuditoriaRoute,
  AppConfiguracionRoute: AppConfiguracionRoute,
  AppEmpresasRoute: AppEmpresasRoute,
  AppHorariosRoute: AppHorariosRoute,
  AppIntegracionRoute: AppIntegracionRoute,
  AppMarcacionesRoute: AppMarcacionesRoute,
  AppMarcadoresRoute: AppMarcadoresRoute,
  AppPerfilRoute: AppPerfilRoute,
  AppSedesRoute: AppSedesRoute,
  AppSolicitudesRoute: AppSolicitudesRoute,
  AppTareoRoute: AppTareoRoute,
  AppTrabajadoresRoute: AppTrabajadoresRoute,
  AppIndexRoute: AppIndexRoute,
  AppEmpresasCompanyIdRoute: AppEmpresasCompanyIdRoute,
  AppMarcadoresTerminalIdRoute: AppMarcadoresTerminalIdRoute,
  AppSedesSiteIdRoute: AppSedesSiteIdRoute,
  AppTrabajadoresWorkerIdRoute: AppTrabajadoresWorkerIdRoute,
  AppIntegracionEjecucionesRunIdRoute: AppIntegracionEjecucionesRunIdRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  IngresarRoute: IngresarRoute,
  OlvideContrasenaRoute: OlvideContrasenaRoute,
  ContrasenaTokenRoute: ContrasenaTokenRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
